<div class="alert alert-danger d-flex align-items-center gap-2 rounded-4 border-0 mb-0" role="alert">
  <fa-icon class="text-danger fs-5 mt-1" [icon]="faCircleExclamation"></fa-icon>
  <div>
    @if (title?.trim()) {
      <div class="fw-bold">{{ title }}</div>
    }
    @for (line of messageLines; track $index) {
      <div>{{ line }}</div>
    }
  </div>
</div>
